'use client'
import {
  axios,
  Common,
  dynamic,
  HttpService,
  Messages,
  // ReactFlagsSelect,
  RingBuilder,
  ServiceEndpoints
} from '@/config/NextImport'
import Link from 'next/link'
import { useEffect, useRef, useState } from 'react'
import { usePathname, useRouter, useSearchParams } from 'next/navigation'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, AppState } from '@/lib/store'
import { getSettingOptions } from '@/lib/features/settingSlice'
import Cookies from 'js-cookie'
import { clearWishList, getWishlistItems, getWishListProduct } from '@/lib/features/wishlistSlice'
import { clearCart, getCartProducts, getCustomerCartItem } from '@/lib/features/cartSlice'
import { LoggedInUser } from '@/lib/features/userSlice'
import {
  setCompareProducts,
  updateComparePriceFromCookie
} from '@/lib/features/compareProductsSlice'
import {
  setRecentViewProductsProducts,
  updateRecentViewPriceFromCookie
} from '@/lib/features/recentViewProducts'
import VoiceSearch from '../common/VoiceSearch'
import useWebSocket from '@/hooks/useWebSocket'
import { getQueryClient } from '@/lib/get-query-client'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faLocationDot, faPhone } from '@fortawesome/free-solid-svg-icons'
// import { loadGetInitialProps } from 'next/dist/shared/lib/utils'
const QuizPopup = dynamic(() => import('@/components/home/QuizPopup'))
const Login = dynamic(() => import('@/components/user/Login'))
const Register = dynamic(() => import('@/components/user/Register'))
const ForgotPassword = dynamic(() => import('@/components/user/ForgotPassword'))
const MiniCart = dynamic(() => import('./MiniCart'))
const ReactFlagsSelect = dynamic(() => import('react-flags-select'), {
  ssr: false, // Prevents server-side errors since this uses browser APIs
  loading: () => <div className="h-10 w-40 animate-pulse bg-gray-200" /> // Optional: a placeholder
})
const Header = (props: any) => {
  const categories = props.menuItems
  const router = useRouter()
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const parentCategories = props.menuItems.filter((x: any) => x.parent_id === 0) || []
  const [AnnouncementBar, setAnnouncementBar] = useState<any>({})
  const navbarRef = useRef<any>(null)
  const [SearchTerm, setSearchTerm] = useState<string>('')
  const [selectedCountry, setSelectedCountry] = useState('')
  const [countries, setCountries] = useState<any>([])
  const [countryLabels, setCountryLabels] = useState<any>([])
  const [countryCodes, setCountryCodes] = useState<any>([])
  const [isQuiz, setQuiz] = useState<boolean>(false)
  const { settingOptions } = useSelector((state: AppState) => state.settings)
  const { wishlistProducts } = useSelector((state: AppState) => state.wishlist)
  const { cartListProducts } = useSelector((state: AppState) => state.cart)
  const { userData } = useSelector((state: AppState) => state.user)
  const dispatch = useDispatch<AppDispatch>()
  const socket = useWebSocket()
  const queryClient = getQueryClient()
  const searchInputRef = useRef<HTMLInputElement | null>(null)

  useEffect(() => {
    dispatch(getSettingOptions())
    dispatch(LoggedInUser())
    const localCompareProductsData = JSON.parse(
      Common.decryptData(localStorage.getItem(Messages.CompareProducts) || '[]')
    )
    if (localCompareProductsData) {
      dispatch(setCompareProducts(localCompareProductsData))
    }
    var totalRecentProduct = []
    if (localStorage.getItem(Messages.last_recent_product) !== undefined) {
      totalRecentProduct = JSON.parse(
        Common.decryptData(localStorage.getItem(Messages.last_recent_product)) || '[]'
      )
    }
    dispatch(setRecentViewProductsProducts(totalRecentProduct))
    GetCountryList()
  }, [])

  useEffect(() => {
    if (settingOptions) {
      const AppVersion = settingOptions.filter((x: any) => x.hj_key === 'NewUpdateVersion')[0]
        ?.hj_value
      if (AppVersion) {
        let currentVersion = localStorage.getItem('version')
        if (!currentVersion) {
          localStorage.removeItem('currency')
          localStorage.removeItem('priceColumn')
          localStorage.removeItem('country')
          localStorage.setItem('version', AppVersion)
          GetCountryList()
        } else if (AppVersion !== currentVersion) {
          localStorage.removeItem('currency')
          localStorage.removeItem('priceColumn')
          localStorage.removeItem('country')
          localStorage.setItem('version', AppVersion)
          GetCountryList()
        }
      }
    }
  }, [settingOptions, pathname])

  useEffect(() => {
    if (settingOptions?.length > 0) {
      let customerCarePhone = ''
      let customerCareEmail = ''
      let isShowAnnouncement = ''
      let announcementText = ''
      let facebookAppId = ''
      let googleClientId = ''
      settingOptions.map((item: any) => {
        if (item[Messages.HarmonySettingKey] === Messages.CustomerCareNumber)
          customerCarePhone = item[Messages.GlobalSettingValue]

        if (item[Messages.HarmonySettingKey] === Messages.CustomerSupportEmail)
          customerCareEmail = item[Messages.GlobalSettingValue]

        if (item[Messages.HarmonySettingKey] === Messages.IsShowAnnouncementBar)
          isShowAnnouncement = item[Messages.GlobalSettingValue]

        if (item[Messages.HarmonySettingKey] === Messages.AnnouncementText)
          announcementText = item[Messages.GlobalSettingValue]

        if (item[Messages.HarmonySettingKey] === Messages.GoogleClientId)
          googleClientId = item[Messages.GlobalSettingValue]

        if (item[Messages.HarmonySettingKey] === Messages.FacebookAppId)
          facebookAppId = item[Messages.GlobalSettingValue]
        return true
      })

      setAnnouncementBar({
        is_show_announcement: isShowAnnouncement,
        customer_care_phone: customerCarePhone,
        customer_care_email: customerCareEmail,
        announcement_text: announcementText
      })
      // setFacebookAppId(facebookAppId)
      // setGoogleAppId(googleClientId)
    }
  }, [settingOptions])
  useEffect(() => {
    const fetchData = async () => {
      await getItemsFromWishlist()
      await getItemsFromCart()
      await updateSoldDiamondInSteps()
    }
    fetchData()
  }, [pathname])

  const getItemsFromWishlist = async () => {
    if (userData.user !== undefined && userData.user !== null) {
      await dispatch(getWishlistItems(userData.user))
    }
    setTimeout(async () => {
      await dispatch(getWishListProduct())
    }, 300)
  }

  const getItemsFromCart = async () => {
    if (userData.user !== undefined && userData.user !== null) {
      await dispatch(getCustomerCartItem(userData.user))
    }
    setTimeout(async () => {
      await dispatch(getCartProducts())
    }, 300)
  }

  useEffect(() => {
    if (!socket) return
    const handleMessage = async (event: MessageEvent) => {
      try {
        const data = JSON.parse(event.data)
        if (data.message === 'cart-updated') {
          await getItemsFromCart()
        } else if (data.message === 'Wishlist-updated') {
          await getItemsFromWishlist()
        } else if (data.message === 'setting-option-updated') {
          await dispatch(getSettingOptions())
        } else if (data.message === 'product-updated') {
          setTimeout(() => {
            queryClient.invalidateQueries({ queryKey: ['settingList'], refetchType: 'active' })
            queryClient.invalidateQueries({ queryKey: ['diamondList'], refetchType: 'active' })
          }, 6000)
        } else if (data.message === 'diamond-updated') {
          queryClient.invalidateQueries({ queryKey: ['diamondList'], refetchType: 'active' })
          localStorage.removeItem(Messages.last_recent_product)
          localStorage.removeItem(Messages.CompareProducts)
        }
      } catch (err) {
        console.error('Invalid WebSocket message:', event.data)
      }
    }

    socket.onmessage = handleMessage

    return () => {
      socket.onmessage = null
    }
  }, [socket])

  const handleVoiceInput = (text: string) => {
    setSearchTerm(text)
    router.push('/search?param=' + text)
  }
  const getLocationData = async () => {
    const res = await axios.get('https://geolocation-db.com/json/')
    return res.data ?? []
  }
  const GetCountryList = async () => {
    const localCurrency = Common.decryptData(localStorage.getItem(Messages.Currency)) || undefined
    let currency = Common.isJSON(localCurrency) ? JSON.parse(localCurrency) : []
    if (!Array.isArray(currency)) currency = []
    let countryId = 9
    let priceCol = 'GB_price'
    if (currency.length < 1) {
      try {
        const response = await HttpService.postApi(ServiceEndpoints.GetCountryList, null)
        const result = response?.result
        currency = Array.isArray(result?.[0])
          ? result[0]
          : Array.isArray(result)
            ? result
            : []
      } catch {
        currency = []
      }
      if (!Array.isArray(currency) || currency.length < 1) {
        currency = [
          {
            id: 9,
            Code: 'GB',
            name: 'United Kingdom',
            currency_symbol: '£',
            currency_name: 'GBP'
          }
        ]
      }
      let location: any = {}
      try {
        location = await getLocationData()
      } catch {
        location = {}
      }
      const userCountry = currency.filter(
        (item: { Code: any }) => item.Code === location?.country_code
      )

      if (userCountry.length > 0) {
        countryId = parseInt(userCountry[0].id)
        priceCol = userCountry[0].Code + '_price'
      }

      Cookies.set(Messages.Country, countryId.toString(), { 
        expires: 30, 
        path: '/', 
        secure: true, 
        sameSite: 'lax' 
      });

      Cookies.set(Messages.PriceColumn, priceCol, { 
        expires: 30, 
        path: '/', 
        secure: true, 
        sameSite: 'lax' 
      });
      localStorage.setItem(Messages.Currency, Common.encryptData(JSON.stringify(currency)))
    }
    const data = Array.isArray(currency) ? currency : []

    const codes: string[] = []
    const labels: Record<string, string> = {}

    if (Cookies.get(Messages.Country)) {
      countryId = parseInt(Cookies.get(Messages.Country)!)
    } else {
      Cookies.set(Messages.Country, countryId.toString(), { 
        expires: 30, 
        path: '/', 
        secure: true, 
        sameSite: 'lax' 
      })
      const priceCol = data.find((x: any) => x.id === countryId)?.Code + '_price'
      Cookies.set(Messages.PriceColumn, priceCol, { 
        expires: 30, 
        path: '/', 
        secure: true, 
        sameSite: 'lax' 
      })
    }
    localStorage.setItem(Messages.Currency, Common.encryptData(JSON.stringify(data)))

    for (let i = 0; i < data.length; i++) {
      if (countryId === parseInt(data[i].id)) {
        setSelectedCountry(data[i].Code)
      }
      codes.push(data[i].Code)
      labels[data[i].Code] = data[i].name
    }

    setCountryCodes(codes)
    setCountryLabels(labels)
    setCountries(data)

    /*if (currency.length > 0) {
      const data = currency
      let countryId = 9
      const codes: string[] = []
      const labels: Record<string, string> = {}

      if (Cookies.get(Messages.Country)) {
        countryId = parseInt(Cookies.get(Messages.Country)!)
      } else {
        Cookies.set(Messages.Country, countryId.toString(), { expires: 30 })
        const priceCol = data.find((x: any) => x.id === countryId)?.Code + '_price'
        Cookies.set(Messages.PriceColumn, priceCol, { expires: 30 })
      }
      localStorage.setItem(Messages.Currency, Common.encryptData(JSON.stringify(data)))

      for (let i = 0; i < data.length; i++) {
        if (countryId === data[i].id) {
          setSelectedCountry(data[i].Code)
        }
        codes.push(data[i].Code)
        labels[data[i].Code] = data[i].name
      }

      setCountryCodes(codes)
      setCountryLabels(labels)
      setCountries(data)
    } else {
      const response = await HttpService.postApi(ServiceEndpoints.GetCountryList, null)
      const data = response.result[0]
      localStorage.setItem(Messages.Currency, Common.encryptData(JSON.stringify(data)))
      let countryId = 9
      const codes: string[] = []
      const labels: Record<string, string> = {}
      if (Cookies.get(Messages.Country)) {
        countryId = parseInt(Cookies.get(Messages.Country)!)
      } else {
        Cookies.set(Messages.Country, countryId.toString(), { expires: 30 })
        const priceCol = data.find((x: any) => x.id === countryId)?.Code + '_price'
        Cookies.set(Messages.PriceColumn, priceCol, { expires: 30 })
      }

      for (let i = 0; i < data.length; i++) {
        if (countryId === data[i].id) {
          setSelectedCountry(data[i].Code)
        }
        codes.push(data[i].Code)
        labels[data[i].Code] = data[i].name
      }

      setCountryCodes(codes)
      setCountryLabels(labels)
      setCountries(data)
    }*/
  }
  const updateCustomizeProduct = async () => {
    const storageSteps = RingBuilder.getRingBuilder()

    const param = {
      products: storageSteps
    }
    const response = await HttpService.postApi(
      ServiceEndpoints.UpdateBuilderFormattedPrice,
      param,
      false
    )

    RingBuilder.setRingBuilder(response.result)
  }

  const updateSoldDiamondInSteps = async () => {
    let steps: any = RingBuilder.getRingBuilder()
    if (steps !== null && steps !== undefined) {
      const stepIndex = steps.findIndex((item: any) => item.step === 'diamond')
      const diamondSku = steps[stepIndex].selected_productid
      if (diamondSku !== null && diamondSku !== '' && diamondSku !== undefined) {
        const param = {
          sku: diamondSku
        }
        steps = await new Promise((resolve) => {
          HttpService.postApi(ServiceEndpoints.checkDiamondSoldFlag, param).then((response) => {
            if (response.result.is_sold !== undefined && response.result.is_sold) {
              steps[stepIndex].product.is_sold = 1
              resolve(steps)
            }
          })
        })
        RingBuilder.setRingBuilder(steps)
      }
    }
  }

  const changeCurrency = async (code: string) => {
    setSelectedCountry(code)

    const selectedCountry = countries.find((country: any) => country.Code === code)

    if (selectedCountry) {
      Cookies.set(Messages.Country, selectedCountry.id.toString(), { 
        expires: 30, 
        path: '/', 
        secure: true, 
        sameSite: 'lax' 
      });

      Cookies.set(Messages.PriceColumn, `${selectedCountry.Code}_price`, { 
        expires: 30, 
        path: '/', 
        secure: true, 
        sameSite: 'lax' 
      });
    }

    await updateCustomizeProduct()
    const params = new URLSearchParams(searchParams.toString())
    params.delete('price')
    queryClient.clear()
    const newUrl = `${pathname}${params.toString() ? `?${params}` : ''}`
    router.replace(newUrl)
    dispatch(updateRecentViewPriceFromCookie())
    dispatch(updateComparePriceFromCookie())
    window.location.href = newUrl // reload with updated URL
  }

  const handleSearchBox = () => {
    setSearchTerm('')
    searchInputRef.current?.focus()
  }
  const closeSearchBox = () => {
    document.getElementById('search-bar-box')?.classList.remove('active')
    document.getElementById('search-bar-mobile')?.classList.remove('active')
    // document.getElementById('sidebar-search-mobile').classList.remove('active')
  }
  const handleKeyDown = (e: any) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      if (SearchTerm === '') return
      router.push('/search?param=' + e.target.value)
      closeSearchBox()
      setSearchTerm('')
    }
  }

  const backMenu = () => {
    navbarRef.current?.focus()
  }
  const DiamondQuizClick = () => {
    setQuiz(true)
  }
  const onCloseModal = () => {
    setQuiz(false)
  }
  const handleNavigation = (url: string) => {
    sessionStorage.removeItem('settingListScrollY')
    sessionStorage.removeItem('diamondListScrollY')
    router.push(url)
  }

  /** Crawlable href without query; leave tel/mailto/external URLs unchanged. */
  const toCleanPath = (url: string) => {
    if (!url) return ''
    if (/^(tel:|mailto:|https?:\/\/)/i.test(url)) return url
    return url.split('?')[0] || ''
  }
  //logout
  const handleLogout = () => {
    Cookies.remove(Messages.WebsiteAppState)
    Cookies.remove(Messages.uuid)
    localStorage.removeItem(Messages.grecaptcha)
    localStorage.removeItem(Messages.pageId)
    localStorage.removeItem(Messages.PromoCode)
    localStorage.removeItem(Messages.CartProducts)
    Cookies.remove('_uuid_socket')
    dispatch(LoggedInUser())
    dispatch(clearWishList())
    dispatch(clearCart())
    router.push('/')
  }
  return (
    <>
      <Login />
      <Register />
      <ForgotPassword />
      {isQuiz ? <QuizPopup onCloseModal={onCloseModal} /> : ''}
      <header
        id="fixed-top"
        className="header"
      >
        {Object.keys(AnnouncementBar).length > 0 &&
          AnnouncementBar.is_show_announcement.toLowerCase() === 'yes' && (
            <div className="top-bar d-none">
              <div className="container-fluid">
                <ul>
                  <li
                    key="phone"
                    className="d-none d-md-block"
                  >
                    <Link href={AnnouncementBar.customer_care_phone ? `tel:${AnnouncementBar.customer_care_phone}` : '#'}>
                      Tel. {AnnouncementBar.customer_care_phone}
                    </Link>
                  </li>
                  <li key="free_shipping">{AnnouncementBar.announcement_text}</li>
                  <li
                    key="email"
                    className="d-none d-md-block"
                  >
                    <Link href={AnnouncementBar.customer_care_email ? `mailto:${AnnouncementBar.customer_care_email}` : '#'}>
                      {AnnouncementBar.customer_care_email}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          )}
        <div className="top-bar">
          <div className="container-fluid">
            <ul className="justify-content-center">
              <li>
                Need a ring ASAP?<Link href="/book-an-appointment"> Reach out now.</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="middle-bar">
          <div className="container-fluid">
            <div className="row align-items-center align-items-lg-end justify-content-between">
              <div className="col-7 col-md-7 col-lg-4 order-md-1 pe-0 header-left-col">
                <div className="header-left">
                  <button
                    ref={navbarRef}
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarNavDropdown"
                    aria-controls="navbarNavDropdown"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                  >
                    <span className="navbar-toggler-icon"></span>
                    <span className="navbar-toggler-icon"></span>
                    <span className="navbar-toggler-icon"></span>
                  </button>
                  <Link
                    href="/"
                    className="mobile-logo d-lg-none"
                  >
                    <img
                      src={Common.setImagePath('assets/images/logo/logo-brand-white.svg')}
                      height={45}
                      width={200}
                      alt="Harmony Jewels"
                    />
                  </Link>
                  <ul className="header-left-search-flag">
                    <li>
                      <div className="flag-bar-box">
                        <ReactFlagsSelect
                          countries={countryCodes}
                          customLabels={countryLabels}
                          selected={selectedCountry}
                          onSelect={(e) => changeCurrency(e)}
                        />
                      </div>
                    </li>

                    <li className="call-bar d-md-none d-block pe-0">
                      {AnnouncementBar?.customer_care_phone && (
                        <Link 
                          href={`tel:${AnnouncementBar.customer_care_phone}`} 
                          aria-label="Call customer support"
                        >
                          <FontAwesomeIcon icon={faPhone} />
                        </Link>
                      )}
                    </li>

                    <li className="dropdown needhelp-menu d-md-block d-none">
                      <span
                        className="needhelp-btn"
                        id="NeedHelpButton"
                        data-bs-toggle=""
                        aria-expanded="false"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#e7dde1"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="feather feather-headphones"
                        >
                          <path d="M3 18v-6a9 9 0 0 1 18 0v6"></path>
                          <path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"></path>
                        </svg>
                        <span className="d-none d-md-block">Need Help?</span>
                      </span>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby=" "
                      >
                        <li>
                          <Link href={AnnouncementBar?.customer_care_phone ? `tel:${AnnouncementBar.customer_care_phone}` : '#'}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="22"
                              height="22"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#232323"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="feather feather-phone"
                            >
                              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                            </svg>
                            {AnnouncementBar?.customer_care_phone}
                          </Link>
                        </li>
                        <li>
                          <Link href="/book-an-appointment">
                            <img
                              src={Common.setImagePath(
                                'assets/images/icon/virtual-appointment-black.svg'
                              )}
                              className=""
                              alt="Need Help?"
                              loading="lazy"
                            />
                            Virtual Appointment
                          </Link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-5 col-md-3 col-lg-4 order-md-3 pe-lg-3 ps-0 header-right-col">
                <div className="header-right pb-lg-2">
                  <ul className="header-action-bar">
                    <li className="book-appointment-link">
                      <Link
                        href="/book-an-appointment"
                        className="btn btn-custom custom-hover d-inline-flex align-items-center justify-content-center"
                      >
                        Book <span className="appointment-text">Appointment</span>
                        {/* <svg
                          className="d-md-none"
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#e7dde1"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M21 10H3M21 12.5V8.8C21 7.11984 21 6.27976 20.673 5.63803C20.3854 5.07354 19.9265 4.6146 19.362 4.32698C18.7202 4 17.8802 4 16.2 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V17.2C3 18.8802 3 19.7202 3.32698 20.362C3.6146 20.9265 4.07354 21.3854 4.63803 21.673C5.27976 22 6.11984 22 7.8 22H12M16 2V6M8 2V6M14.5 19L16.5 21L21 16.5" />
                        </svg> */}
                      </Link>
                    </li>
                    <li className="search-bar">
                      <div className="search-bar-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          onClick={handleSearchBox}
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="white"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="feather feather-search active"
                        >
                          <circle
                            cx="11"
                            cy="11"
                            r="8"
                          ></circle>
                          <line
                            x1="21"
                            y1="21"
                            x2="16.65"
                            y2="16.65"
                          ></line>
                        </svg>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          onClick={handleSearchBox}
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="white"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="feather feather-close "
                        >
                          <line
                            x1="18"
                            y1="6"
                            x2="6"
                            y2="18"
                          ></line>
                          <line
                            x1="6"
                            y1="6"
                            x2="18"
                            y2="18"
                          ></line>
                        </svg>
                      </div>
                      <div
                        id="search-bar-box"
                        className=""
                      >
                        <form>
                          <input
                            type="text"
                            placeholder="Search"
                            id="mainSearchBox"
                            ref={searchInputRef}
                            onKeyDownCapture={handleKeyDown}
                            value={SearchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                        </form>
                      </div>
                    </li>

                    <li className="cart-bar">
                      <Link
                        href="/cart"
                        className="cart-link"
                      >
                        <svg
                          aria-hidden="true"
                          focusable="false"
                          role="presentation"
                          width="24"
                          height="24"
                          className="icon icon-bag"
                          viewBox="0 0 64 64"
                        >
                          <g
                            fill="none"
                            stroke="#e7dde1"
                            strokeWidth="5"
                          >
                            <path d="M25 26c0-15.79 3.57-20 8-20s8 4.21 8 20"></path>
                            <path d="M14.74 18h36.51l3.59 36.73h-43.7z"></path>
                          </g>
                        </svg>
                        <span className="count-number">
                          {cartListProducts?.products !== undefined &&
                          cartListProducts.products !== null
                            ? cartListProducts.products.length
                            : 0}
                        </span>
                      </Link>
                      <MiniCart />
                    </li>

                    <li className="wishlist-bar">
                      <Link
                        href="/wishlist"
                        className="wishlist-link"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#e7dde1"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="feather feather-heart"
                        >
                          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                        </svg>
                        <span className="count-number">{wishlistProducts.length} </span>
                      </Link>
                    </li>

                    <li className="user-bar d-none d-md-block">
                      {userData?.user ? (
                        <span className="user-link cursor">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#c29cac"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="feather feather-user"
                          >
                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                            <circle
                              cx="12"
                              cy="7"
                              r="4"
                            ></circle>
                          </svg>
                        </span>
                      ) : (
                        <span
                          className="user-link cursor"
                          data-bs-toggle="modal"
                          data-bs-target="#LoginModal"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="white"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="feather feather-user"
                          >
                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                            <circle
                              cx="12"
                              cy="7"
                              r="4"
                            ></circle>
                          </svg>
                        </span>
                      )}
                      {userData?.user ? (
                        <ul className="user-menu">
                          <li>
                            <Link href="/orders">Orders</Link>
                          </li>
                          <li>
                            <Link href="/accountdetails">Account Details</Link>
                          </li>
                          <li>
                            <Link href="/changepassword">Change Password</Link>
                          </li>
                          <li>
                            <span
                              className="cursor"
                              title="Logout"
                              onClick={handleLogout}
                            >
                              Logout
                            </span>
                          </li>
                        </ul>
                      ) : null}
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-auto col-lg-4 order-md-2 d-none d-lg-block col-logo text-center">
                <div className="header-logo d-none d-md-block text-center">
                  <Link href="/">
                    <img
                      src={Common.setImagePath('assets/images/logo/logo-brand-white.svg')}
                      alt="Harmony Jewels"
                      height={50}
                      width={230}
                    />
                  </Link>
                </div>
              </div>
            </div>

            <nav className="navbar navbar-expand-lg navbar-lightheader-nav-section justify-content-center">
              <div className="col-menu">
                <div
                  className="collapse navbar-collapse justify-content-center"
                  id="navbarNavDropdown"
                >
                  <button
                    className="navbar-toggler btn-close"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarNavDropdown"
                    aria-controls="navbarNavDropdown"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                  ></button>

                  <ul className="navbar-nav">
                    <li className="mobile-menu-banner d-block d-lg-none">
                      <div className="mobile-banner-content">
                        <p>Diamonds Bands</p>
                        <Link
                          className="btn btn-black shop-button"
                          href="/engagement-rings/all-settings"
                          onClick={(e) => {
                            e.preventDefault()
                            handleNavigation('/engagement-rings/all-settings?style=Diamond%20Band')
                          }}
                        >
                          Shop Now
                        </Link>
                      </div>
                      <img
                        src={Common.setImagePath('assets/images/mobile-header-banner.png')}
                        alt="mobile banner"
                      />
                    </li>

                    {parentCategories.length > 0 &&
                      parentCategories.map((FirstLevel: any, index: number) => {
                        return categories.filter((x: any) => x.parent_id === FirstLevel.id)
                          .length === 0 ? (
                          <li
                            className="nav-item"
                            key={index}
                          >
                            <Link
                              className="nav-link single-link"
                              href={toCleanPath(
                                FirstLevel.menu_type === 'custom_link'
                                  ? FirstLevel.link || ''
                                  : FirstLevel.slug.replace('?setting=', '/') || ''
                              )}
                              onClick={(e) => {
                                const full =
                                  FirstLevel.menu_type === 'custom_link'
                                    ? FirstLevel.link || ''
                                    : FirstLevel.slug.replace('?setting=', '/') || ''
                                if (full.includes('?') && !/^(tel:|mailto:|https?:\/\/)/i.test(full)) {
                                  e.preventDefault()
                                  handleNavigation(full)
                                }
                              }}
                            >
                              {FirstLevel.title}
                            </Link>
                          </li>
                        ) : (
                          <li
                            className="nav-item"
                            key={index}
                          >
                            <span
                              className="nav-link dropdown-toggle pointer"
                              data-bs-toggle="dropdown"
                              style={{ cursor: 'text' }}
                              // data-bs-target={'#megaNavDropdown_' + index}
                              aria-expanded="false"
                              aria-current="page"
                            >
                              {FirstLevel.title}
                              <span className="nav-arrow d-lg-none">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="21"
                                  height="21"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="#505050"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-chevron-right"
                                >
                                  <polyline points="9 18 15 12 9 6"></polyline>
                                </svg>
                              </span>
                            </span>
                            <div
                              id={'megaNavDropdown_' + index}
                              className="megamenu dropdown-menu"
                              aria-labelledby="navbarDropdown"
                            >
                              <button
                                type="button"
                                className="nav-link menu-back dropdown-toggle d-lg-none"
                                // data-bs-toggle=""
                                // data-bs-target={'#megaNavDropdown_' + index}
                                aria-expanded="false"
                                onClick={backMenu}
                                // data-bs-toggle="dropdown"
                                // aria-expanded="false"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="#505050"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-chevron-left"
                                >
                                  <polyline points="15 18 9 12 15 6"></polyline>
                                </svg>
                                BACK
                              </button>
                              <div className="container">
                                <div className="row">
                                  <div className="col-md-9 subnav-bar-left">
                                    <div className="row g-3 subnav-bar-row">
                                      {categories
                                        .filter((x: any) => x.parent_id === FirstLevel.id)
                                        .map((SecondLevel: any, subIndex: number) => (
                                          <div
                                            className="col-md-3 subnav-bar-item"
                                            key={subIndex}
                                          >
                                            <div
                                              className={
                                                'subnav-bar-title' + ' ' + SecondLevel.css_class
                                              }
                                            >
                                              <span>{SecondLevel.title}</span>
                                            </div>
                                            <ul
                                              className={
                                                SecondLevel.menu_column === 2
                                                  ? 'subnav-bar-menu subnav-two-column'
                                                  : 'subnav-bar-menu'
                                              }
                                            >
                                              {categories
                                                .filter((x: any) => x.parent_id === SecondLevel.id)
                                                .map((ThirdLevel: any) => (
                                                  <li key={ThirdLevel.id}>
                                                    <Link
                                                      className={'subnav-bar-menu-link ' + subIndex}
                                                      href={toCleanPath(ThirdLevel.slug)}
                                                      onClick={(e) => {
                                                        e.preventDefault()
                                                        handleNavigation(ThirdLevel.slug)
                                                      }}
                                                    >
                                                      {ThirdLevel.css_class !== '' ? (
                                                        <span className={'menu-icon'}>
                                                          <img
                                                            className="nav-icon"
                                                            src={Common.setImagePath(
                                                              `assets/images/icon/${ThirdLevel.css_class}`
                                                            )}
                                                            loading="lazy"
                                                            alt="icon"
                                                            height={20}
                                                          />
                                                          {ThirdLevel.title}
                                                        </span>
                                                      ) : (
                                                        <span>{ThirdLevel.title}</span>
                                                      )}
                                                    </Link>
                                                  </li>
                                                ))}
                                              {FirstLevel.menu_column === 0 &&
                                              subIndex === 0 &&
                                              index === 1 ? (
                                                <li className="nav-icon-7-2">
                                                  <span className="subnav-bar-menu-link">
                                                    <span
                                                      className="menu-icon"
                                                      onClick={DiamondQuizClick}
                                                    >
                                                      <img
                                                        className="nav-icon"
                                                        src={Common.setImagePath(
                                                          'assets/images/icon/start_with-diamond.svg'
                                                        )}
                                                        alt="icon"
                                                        loading="lazy"
                                                        height={25}
                                                      />{' '}
                                                      Start with Our Diamond Quiz
                                                    </span>
                                                  </span>
                                                </li>
                                              ) : (
                                                ''
                                              )}
                                            </ul>
                                          </div>
                                        ))}
                                      {typeof FirstLevel.title === 'string' &&
                                        FirstLevel.title.toLowerCase().includes('engagement') && (
                                          <div className="col-md-3 subnav-bar-item">
                                            <div className="subnav-bar-title">
                                              <span>Bespoke</span>
                                            </div>
                                            <ul className="subnav-bar-menu">
                                              <li>
                                                <Link
                                                  className="subnav-bar-menu-link"
                                                  href="/bespoke-engagement-rings"
                                                  onClick={(e) =>
                                                    handleNavigation('/bespoke-engagement-rings')
                                                  }
                                                >
                                                  <span>Bespoke Engagement Rings</span>
                                                </Link>
                                              </li>
                                            </ul>
                                          </div>
                                        )}
                                    </div>
                                  </div>
                                  <div className="col-md-3 subnav-bar-right">
                                    <div className="subnav-bar-item">
                                      <div className="subnav-bar-banner">
                                        {FirstLevel.css_class !== undefined &&
                                        FirstLevel.css_class !== '' ? (
                                          <img
                                            src={Common.setImagePath(
                                              `assets/images/${FirstLevel.css_class}`
                                            )}
                                            loading="lazy"
                                            alt="Ring"
                                          />
                                        ) : (
                                          ''
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                        )
                      })}

                    <li className="nav-item d-block d-lg-none user-nav-item">
                      {userData.user ? (
                        <span
                          className="nav-link dropdown-toggle pointer"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          aria-current="page"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#c29cac"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="feather feather-user"
                          >
                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                            <circle
                              cx="12"
                              cy="7"
                              r="4"
                            ></circle>
                          </svg>{' '}
                          <span className="me-auto ps-2">My Account</span>
                        </span>
                      ) : (
                        <span
                          className="nav-link"
                          data-bs-toggle="modal"
                          data-bs-target="#LoginModal"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#333"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="feather feather-user"
                          >
                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                            <circle
                              cx="12"
                              cy="7"
                              r="4"
                            ></circle>
                          </svg>{' '}
                          <span className="me-auto ps-2">Sign In</span>
                        </span>
                      )}

                      {userData.user ? (
                        <div
                          id="megaNavDropdown_user"
                          className="megamenu dropdown-menu"
                          aria-labelledby="navbarDropdown"
                        >
                          <span
                            className="nav-link menu-back dropdown-toggle d-md-none"
                            data-bs-toggle="collapse"
                            data-bs-target="#megaNavDropdown_user"
                            aria-expanded="false"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#505050"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="feather feather-chevron-left"
                            >
                              <polyline points="15 18 9 12 15 6"></polyline>
                            </svg>
                            BACK
                          </span>
                          <div className="container-fluid">
                            <div className="row">
                              <div className="col-lg-3 subnav-bar-item">
                                <ul className="subnav-bar-menu">
                                  <li>
                                    <Link
                                      className="subnav-bar-menu-link"
                                      href="/orders"
                                    >
                                      Orders
                                    </Link>
                                  </li>
                                  <li>
                                    <Link
                                      className="subnav-bar-menu-link"
                                      href="/accountdetails"
                                    >
                                      Account Details
                                    </Link>
                                  </li>
                                  <li>
                                    <Link
                                      className="subnav-bar-menu-link"
                                      href="/changepassword"
                                    >
                                      Change Password
                                    </Link>
                                  </li>
                                  <li>
                                    <span
                                      className="subnav-bar-menu-link cursor"
                                      title="Logout"
                                      onClick={handleLogout}
                                    >
                                      Logout
                                    </span>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </li>
                  </ul>

                  <div className="mobile-menu-footer-block d-block d-lg-none">
                    <h4>Contact Us</h4>
                    <ul>
                      <li>
                        <Link
                          href="https://www.google.com/maps/place/Harmony+Jewels+-+Hatton+Garden+Jewellers/@51.5188725,-0.1081217,15z/data=!4m6!3m5!1s0x48761b4dceb3bd25:0xfb92be782ce3570b!8m2!3d51.5188725!4d-0.1081217!16s%2Fg%2F11bv1lzq55?entry=ttu&g_ep=EgoyMDI1MDUyNi4wIKXMDSoASAFQAw%3D%3D"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <FontAwesomeIcon icon={faLocationDot} />
                        </Link>
                      </li>
                      <li>
                        {AnnouncementBar?.customer_care_phone && (
                          <Link 
                            href={`tel:${AnnouncementBar.customer_care_phone}`} 
                            aria-label="Call customer support"
                          >
                            <FontAwesomeIcon icon={faPhone} />
                          </Link>
                        )}
                      </li>
                      <li>
                        {AnnouncementBar?.customer_care_email && (
                          <Link 
                            href={`mailto:${AnnouncementBar.customer_care_email}`} 
                            aria-label="Email customer support"
                          >
                            <FontAwesomeIcon icon={faEnvelope} />
                          </Link>
                        )}
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="mobile-menu-overlay"></div>
              </div>
            </nav>

            <div
              id="search-bar-mobile"
              className="search-bar d-md-none"
            >
              <div className="search-bar-icon">
                <svg
                  onClick={handleSearchBox}
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#333"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-search active"
                >
                  <circle
                    cx="11"
                    cy="11"
                    r="8"
                  ></circle>
                  <line
                    x1="21"
                    y1="21"
                    x2="16.65"
                    y2="16.65"
                  ></line>
                </svg>
                <svg
                  onClick={handleSearchBox}
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#333"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-close"
                >
                  <line
                    x1="18"
                    y1="6"
                    x2="6"
                    y2="18"
                  ></line>
                  <line
                    x1="6"
                    y1="6"
                    x2="18"
                    y2="18"
                  ></line>
                </svg>
              </div>
              <div
                id="search-bar-box"
                className=""
              >
                <form>
                  <input
                    type="text"
                    placeholder="Search"
                    id="mainSearchBox"
                    autoComplete="off"
                    onKeyDownCapture={handleKeyDown}
                    value={SearchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </form>
                <div className="voice-search-icon">
                  <VoiceSearch
                    onResult={(text) => {
                      handleVoiceInput?.(text)
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  )
}

export default Header
